import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Fade } from "react-reveal";
import Steper from "Component/Steper/Steper";
import CurrencyModal from "Component/Modals/CurrencyModal";
import transakSDK from "@transak/transak-sdk";
import CryptoModal from "Component/Modals/CryptoModal ";
import { useDispatch, useSelector } from "react-redux";
import { getPrice, getCurrency, getCrypto, verifyWallet, getQuoteList, createTransaction } from "store/actions";
import Detailsbox from "Pages/Buydetails/detailsbox";
import Newsteper from "Component/Steper/newSteper";
import ButtonLoader from "Component/Common/ButtonLoader.js";
import PaymentModal from "./payment-model";
import { useTranslation } from 'react-i18next';

import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';

import Processingmodal from "Component/Modals/Processingmodal";
import Loader from "Component/Common/Loader";

import { paymentMethods, platforms } from './uniramp.js';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,

} from "reactstrap";
import { tr } from "@lifi/widget/i18n/index.js";
import useToastr from "helpers/toastr";




const Buypagestepone = () => {
  const navigate = useNavigate();
  const [showCurrency, setShowCurrency] = useState(false);
  const [showPymentModal, setShowPymentModal] = useState(false);
  const [showCrypto, setShowCrypto] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [selectedCrypto, setSelectedCrypto] = useState();
  const [marketPrice, setMarketPrice] = useState(null);
  const [isShowVerification, setIsShowVerification] = useState(false);
  const [isValid, setIsValid] = useState(false);
  let symbol = selectedCurrency?.symbol;
  const { loading, AUDLoading } = useSelector((state) => state?.UniRamp);
  const iframeRef = useRef();
  const { t } = useTranslation();

  const toastr = useToastr();

  const dispatch = useDispatch();

  const [filters, setFiters] = useState({
    page: 1,
    limit: 1000
  })
  const [cryptoValue, setCryptoValue] = useState();
  const [currencyValue, setCurrencyValue] = useState(800);

  const [selectedWallet, setSelectedWallet] = useState();

  let params = {
    fsym: selectedCrypto,
    tsyms: selectedCurrency
  }

  const [fields, setFields] = useState({
    walletAddress: "",
    termsCondition: "",

  })



  const { currencyList } = useSelector((state) => state?.Currency);
  const { cryptoList } = useSelector((state) => state?.Crypto);
  const { user } = useSelector((state) => state?.Login);

  const [processingmodal, setProcessingmodal] = useState(false);

  const [selectedPayMethod, setSelectedPayMethod] = useState();

  const [unirampQuoteList, setUnirampQuoteList] = useState([]);
  const [paymentUrl, setPaymentUrl] = useState("");

 
 

  useEffect(() => {

    if (currencyList?.resdata?.length > 0) {
      setSelectedCurrency(currencyList?.resdata[0]);
      symbol = currencyList?.resdata[0]?.symbol;
    }
  }, [currencyList])


  useEffect(() => {
    setSelectedPayMethod("");
    setSelectedWallet("");
    setUnirampQuoteList([]);
  }, [currencyValue, cryptoValue, selectedCrypto, selectedCurrency])



  useEffect(() => {

    if (cryptoList?.resdata?.length > 0) {
      setSelectedCrypto(cryptoList?.resdata[0])
      setFields({
        ...fields,
        walletAddress: cryptoList?.resdata[0]?.address
      })
    }
  }, [cryptoList])

  useEffect(() => {


    if (cryptoList?.resdata?.length > 0 && currencyList?.resdata?.length > 0) {
      dispatch(getPrice({
        fsym: cryptoList?.resdata[0]?.mainnet_symbol,
        tsyms: currencyList?.resdata[0]?.symbol
      }, callback));

    }

  }, [cryptoList, currencyList])


  const callback = (response) => {

    if (response?.status === 200) {

      if (response?.data?.Response && response?.data?.Response == "Error") {
        setMarketPrice(0);
        setCurrencyValue(0);
        setIsValid(false)
        return toastr.error(response?.data?.Message)
      } else {
        let info = response?.data?.[symbol]
        setIsValid(true)
        setMarketPrice(info);


        let calculatedAmt = currencyValue / info;

        setCryptoValue(calculatedAmt)

      }
    }
  }


  function callGetPrice(obj) {

    dispatch(getPrice({
      ...params,
      fsym: obj?.selectedCrypto?.mainnet_symbol,
      tsyms: obj?.selectedCurrency?.symbol
    }, callback));

  }


  /**
     * Used for getting the currency and crypto listing
     */
  useEffect(() => {
    dispatch(getCurrency({ ...filters }));
    dispatch(getCrypto({ ...filters }));
  }, []);


  const hideCurrencyMod = (obj) => {
    if (obj == undefined) {
      setSelectedCurrency(currencyList?.resdata[0])
      symbol = currencyList?.resdata[0]?.symbol
    } else {
      setSelectedCurrency(obj?.selectedCurrency)
      symbol = obj?.selectedCurrency?.symbol
    }
    setShowCurrency(false);
  }

  const hideCryptoMod = (obj) => {
    if (obj == undefined) {
      setSelectedCrypto(cryptoList?.resdata[0]);
    } else {
      setSelectedCrypto(obj?.selectedCrypto)
    }
    setFields({
      ...fields,
      walletAddress: obj?.selectedCrypto?.address
    })
    setShowCrypto(false);
    symbol = selectedCurrency.symbol;
  }


  const handleCurrencyAmt = (e) => {

    if (marketPrice && e.target.value !== 0) {
      let finalAmt = e.target.value / marketPrice;
      setCryptoValue(finalAmt)
      setCurrencyValue(e.target.value)
    }
  }



  const handleCryptoAmt = (e) => {

    if (marketPrice && e.target.value !== 0) {
      let finalAmt = e.target.value * marketPrice;

      setCryptoValue(e.target.value)
      setCurrencyValue(finalAmt)
    }
  }


  const handleChange = (name) => (e) => {
    setFields(prev => ({ ...prev, [name]: e.target.value }))

  }

  const handleCheckBox = (name) => (e) => {
    setFields(prev => ({ ...prev, [name]: e.target.checked }))
  }


  /**
     * Used for open the model of uniramp with selected platform
     */

  const buyCrypto = (e) => {
    e.preventDefault();

    if (!selectedPayMethod) {

      return toastr.error(t('select_payment_method'))
    }
    if (!selectedWallet) {

      return toastr.error(t('select_wallet'))
    }

    const callback = (response) => {

      if (response?.statusCode == 200) {
        setPaymentUrl(response?.data?.cefiInitiate?.url)
        setShowPymentModal(true);

      } else {
      }
    }
    let data = {
      cefiGateway: selectedWallet?.gateway,
      fiat: selectedCurrency?.symbol,
      fiatAmount: currencyValue.toString(),
      payment: selectedPayMethod?.value,
      chain: selectedCrypto?.type == "token" ? selectedCrypto?.chain : selectedCrypto?.mainnet_symbol,
      crypto: selectedCrypto?._id

    }

    dispatch(createTransaction(data, callback));

  }

  const handleValueChange = (obj) => {


    const callback = (response) => {

      if (response?.statusCode == 200) {
        let data = response.data;
        let filteredPlatform = [];
        if (data.length > 0) {
          filteredPlatform = platforms.map((obj) => {
            const mergeArr = data.find(item1 => item1.gateway === obj.value);
            if (mergeArr) {
              return { ...obj, ...mergeArr }
            }
            return null
          }).filter((itm) => itm !== null)
          setUnirampQuoteList(filteredPlatform)
        }
      } else {
        toastr.error(response?.data?.message)
      }
    }
    let data = {
      fiat: selectedCurrency?.symbol,
      fiatAmount: currencyValue.toString(),
      payment: obj?.value,
      chain: selectedCrypto?.type == "token" ? selectedCrypto?.chain : selectedCrypto?.mainnet_symbol
    }
    dispatch(getQuoteList(data, callback));

    setSelectedPayMethod(obj);
    setSelectedWallet("");
    setUnirampQuoteList([]);

  }


  const handleContent = (obj) => {
    const slugify = str =>
      str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');

    let newSlug = slugify(obj)
    navigate('/' + newSlug)

  }

  /**
     * Used for render the UI of currency part
     */
  const CurrencyDDL = () => {

    return (
      <div className="max-here">

        <Button
          className="btn-click"
          onClick={() => setShowCurrency(true)}
        >
          <img
            src={selectedCurrency && selectedCurrency?.icon}
            alt=""
            className="img-fluid"
          />
          <p>{selectedCurrency && selectedCurrency?.name}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
              fill="#000"
            />
          </svg>
        </Button>
      </div>

    )

  }
 /**
     * Used for render the UI of crypto part
     */
  const CryptoDDL = () => {
    return (
      <div className="max-here">

        <Button
          className="btn-click"
          onClick={() => setShowCrypto(true)}
        >
          <img
            src={selectedCrypto && selectedCrypto?.icon}
            alt=""
            className="img-fluid"
          />
          <p>{selectedCrypto && selectedCrypto?.name}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <path
              d="M21.625 11.625C21.8542 11.8542 21.9688 12.1458 21.9688 12.5C21.9688 12.8542 21.8542 13.1458 21.625 13.375L15.875 19.125C15.75 19.25 15.6146 19.3387 15.4688 19.3912C15.3229 19.4429 15.1667 19.4687 15 19.4687C14.8333 19.4687 14.6717 19.4375 14.515 19.375C14.3592 19.3125 14.2292 19.2292 14.125 19.125L8.375 13.375C8.14584 13.1458 8.03125 12.8542 8.03125 12.5C8.03125 12.1458 8.14584 11.8542 8.375 11.625C8.60417 11.3958 8.89583 11.2812 9.25 11.2812C9.60417 11.2812 9.89584 11.3958 10.125 11.625L15 16.5L19.875 11.625C20.1042 11.3958 20.3958 11.2812 20.75 11.2812C21.1042 11.2812 21.3958 11.3958 21.625 11.625Z"
              fill="#000"
            />
          </svg>
        </Button>
      </div>

    )
  }



  const handleWallet = (obj) => {
    setSelectedWallet(obj);
  }


 /**
     * Used for render the UI of Uniramp module page
     */

  return (
    <Fade>
      <CurrencyModal show={showCurrency}
        onHide={hideCurrencyMod}
        selectedCurrency={selectedCurrency}
        callGetPrice={callGetPrice}
        selectedCrypto={selectedCrypto}
        currencyList={currencyList?.resdata}

      />

      <CryptoModal show={showCrypto}
        onHide={hideCryptoMod}
        selectedCrypto={selectedCrypto}
        callGetPrice={callGetPrice}
        selectedCurrency={selectedCurrency}
        cryptoList={cryptoList?.resdata}


      />

      <Processingmodal
        show={processingmodal}
        onHide={() => setProcessingmodal(false)}
        title={t('request_submitted')}

      />

      {
        paymentUrl &&
        <PaymentModal
          show={showPymentModal}
          onHide={() => setShowPymentModal(!showPymentModal)}
          paymentUrl={paymentUrl}
          iframeRef={iframeRef}
        />

      }


      <section className="home_banner_main buy_page position-relative">
        {loading && <Loader />}

        <div className="top_circle"></div>

        <Container fluid className="position-relative">
          <Row>
            {/* <Col lg={3} md={6} sm={12} className="order-2 order-lg-1">
              <div className="Buystepone_stepper">
              
                <Newsteper/>
              </div>
            </Col> */}
            <Col lg={6} md={12} sm={12} className="order-1 order-lg-2 m-auto">
              <div className="buy_cryptoform position-relative text-start">
                <Form className="buy_crpto_form">
                  <div className="buy_form_head d-flex justify-content-between align-items-center">
                    <h2>{t('buy_sell_crypto')}</h2>
                    {/* <p>
                      (1) <span>First Step</span>
                    </p> */}
                  </div>

                  <div className="Buy_btn_card mt-5">

                    <div className="form_liqudity">
                      <FormGroup className="input_here_wrap">
                        <div className="input_label">
                          <p> {t('you_send')}  </p>
                          <p>{selectedCurrency?.name}</p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="number"
                            value={currencyValue}
                            onChange={handleCurrencyAmt}
                          />
                          <CurrencyDDL />
                        </div>
                      </FormGroup>

                      <div className="centercontent text-start py-3">

                        <p>1 {selectedCrypto?.mainnet_symbol} ~ {marketPrice} <span>{selectedCurrency?.symbol}</span></p>


                      </div>
                      <FormGroup className="input_here_wrap">
                        <div className="input_label">
                          <p>{t('you_get')}</p>
                          <p>{selectedCrypto?.name}</p>
                        </div>

                        <div className="input_wrap">
                          <Input
                            type="number"
                            value={cryptoValue}
                            onChange={handleCryptoAmt}

                          />



                          <CryptoDDL />

                        </div>
                      </FormGroup>


                    </div>
                    {
                      isValid &&
                      <div>
                        {!isShowVerification && <Button className="btn_sign_in w-100 mt-4 btn_theme"
                          // onClick={() => navigate("/buydetails")}
                          disabled={!selectedCurrency?.name && !selectedCurrency?.symbol && true}
                          onClick={() => setIsShowVerification(true)}
                        >
                          {t('continue')}
                        </Button>}
                      </div>
                    }




                  </div>
                  {
                    isShowVerification &&

                    <div>

                      <Col md={12} className="mt-3">
                        <FormGroup>


                          <Label for="formrow-firstname-Input">
                            {t('payment_method')}
                          </Label>
                          <Select
                            value={selectedPayMethod}
                            options={paymentMethods}
                            onChange={handleValueChange}
                            placeholder=""

                            formatOptionLabel={obj => (
                              <div className="transsac_with_icon d-flex justify-content-between align-items-center">
                                <div className="trasack_icon me-2">
                                  <img
                                    src={obj?.image}
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                                <p className="m-0">{obj?.label}</p>
                              </div>
                            )}
                          />
                        </FormGroup>
                      </Col>

                      <Row>

                        <div className="d-flex align-items-center justify-content-center">
                          {AUDLoading && <ButtonLoader />}
                        </div>


                        {
                          unirampQuoteList && unirampQuoteList.length > 0 && unirampQuoteList.map((obj, key) => (
                            <Col lg={6} md={6} sm={12} className="my-4">


                              <div onClick={() => handleWallet(obj)}
                                className={selectedWallet?.value == obj.value ? "transack after_check py-3 px-3 pt-4 position-relative" : "transack py-3 px-3 pt-4  position-relative"}>

                                <div className="check">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill={selectedWallet?.value == obj.value ? "green" : "#ccc"} d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm4.2 8.3l-4.8 4.8c-.4.4-1 .4-1.4 0l-2.2-2.2c-.4-.4-.4-1 0-1.4c.4-.4 1-.4 1.4 0l1.5 1.5l4.1-4.1c.4-.4 1-.4 1.4 0c.4.4.4 1 0 1.4z" /></svg>
                                </div>
                                <div className="transsac_with_icon d-flex justify-content-between align-items-center">

                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="trasack_icon me-2">
                                      <img
                                        src={obj?.image}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <p className="m-0">{obj?.label}</p>
                                  </div>
                                  <div className="transaction_value">

                                    <h4>{obj?.transactionFee} </h4>

                                  </div>
                                </div>

                                <ul className=" p-0 m-0 buy_page_list mt-2">
                                  <li>
                                    <p>{t('rate')}</p>
                                    <p>
                                      {obj?.rate}
                                    </p>
                                  </li>
                                  <li>
                                    <p>{t('crypto_decimal')}</p>
                                    <p>
                                      {obj?.cryptoDecimal}
                                    </p>
                                  </li>
                                  <li>
                                    <p>{t('network_fee')}</p>
                                    <p>
                                      {obj?.networkFee}
                                    </p>
                                  </li>
                                  <li>
                                    <p>{t('crypto_amount')}</p>
                                    <p>
                                      {obj?.cryptoAmount}
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </Col>
                          ))
                        }
                      </Row>




                      <Col lg={12}>
                        <div className="wallet_Address mt-4">
                          <Button
                            className="btn_sign_in w-100 btn_theme"
                            // onClick={() => setbuycryptomodone(true)}

                            onClick={buyCrypto}

                          >
                            {t('buy')}{" " + cryptoValue + " " + selectedCrypto?.mainnet_symbol}
                          </Button>
                        </div>
                      </Col>

                    </div>
                  }
                </Form>
              </div>
            </Col>
            {/* 
            <Col lg={3} md={6} sm={12} className="order-3 order-lg-3 offset-lg-1">
              <Detailsbox />
            </Col> */}

          </Row>
        </Container>
        <div className="bottom_circle"></div>
      </section>
    </Fade>
  );
};

export default Buypagestepone;
